import { SuretyAccountId } from "@inrev/common";
import { useFlags } from "@portal/providers/GlobalFlagsProvider";
import { useMutation } from "@tanstack/react-query";
import { downloadFileFromDataBlob } from "../../../utils/download";
import { useRequest } from "../../../utils/request";

export const useAdminGenerateAccountReport = (accountId: SuretyAccountId) => {
	const { get } = useRequest();
	const { showErrorFlag } = useFlags();

	const mutation = useMutation({
		mutationFn: async () => {
			const response = await get<Response>(
				`/v2/admin/surety/accounts/${accountId}/reports/inrev-report`,
				undefined,
				"response",
			);
			const filename =
				/filename="([^"]+)"/.exec(response.headers.get("content-disposition") ?? "")?.[1] ??
				"inrev-report.pdf";
			return { blob: await response.blob(), filename };
		},
		onSuccess: ({ blob, filename }) => downloadFileFromDataBlob(blob, filename),
		onError: () => showErrorFlag({ message: "Failed to generate inRev Report" }),
	});

	return {
		generateReport: mutation.mutate,
		generateReportIsPending: mutation.isPending,
	};
};
